import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class UpdateButton extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateClick = this.handleUpdateClick.bind(this);
  }

  handleUpdateClick() {
    this.props.getProviderOrdersHistoricLimits();
  }

  render() {
    const {loading, saving} = this.props;

    return (
      <Button secondary
        content='ACTUALIZAR'
        disabled={loading || saving}
        onClick={this.handleUpdateClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providerOrdersControl.loadingHistory,
    'saving': state.providerOrdersControl.saving,
  };
};

const {getProviderOrdersHistoricLimits} = Actions;

export default connect(mapStateToProps, {
  getProviderOrdersHistoricLimits,
})(UpdateButton);
